// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Spinner_spinnerWrapper__1xKzR","wrapper":"Spinner_wrapper__RI7xI","center":"Spinner_center__FxOY8"};